module.exports = __webpack_public_path__ + "img/slider_exp_en.0054e85e.png";